<template>
  <div class="home-view">
    <div class="home-section">
    <Story/>
    </div>
    <div class="home-section">
    <Carousel/>
    </div>
    <div class="home-section">
    <Tabs/>
    </div>
    <div class="home-section">
    <Most/>
    </div>
    <div class="home-section">
    <Partners/>   
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Story from '../components/Stories/Story.vue';
import Carousel from '../components/Carousel/Carousel.vue';
import Fillter from '../components/Fillter/Fillter.vue';
import Tabs from '../components/Tabs/Tabs.vue';
import Most from '../components/Most/Most.vue';
import Partners from '../components/Partners/Partners.vue';
import Real_estate from '../components/Real_estate/Real_estate.vue';

export default defineComponent({
  name: 'HomeView',


  components: {
    Story,
    Carousel,
    Fillter,
    Tabs,
    Most,
    Partners,
    Real_estate
  },
  
});
</script>

<style lang="scss" scoped>
.home-view {
  width: 100%;
  background: #f5f5f5;
}

.home-section {
  margin-bottom: 32px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

@media (max-width: 600px) {
  .home-section {
    margin-bottom: 24px;
  }
}
</style>
